import { render, staticRenderFns } from "./selectchoice2.vue?vue&type=template&id=7a5d6f3d&scoped=true"
import script from "./selectchoice2.vue?vue&type=script&lang=js"
export * from "./selectchoice2.vue?vue&type=script&lang=js"
import style0 from "./selectchoice2.vue?vue&type=style&index=0&id=7a5d6f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d6f3d",
  null
  
)

export default component.exports